import { PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import styles from './Container.module.scss';

export function Container({
  children,
  className,
  ...props
}: PropsWithChildren<{
  className?: string;
}>) {
  return (
    <div className={clsx(styles.container, className)} {...props}>
      {children}
    </div>
  );
}
